import CountryBadgesMerged from './CountryBadgesMerged';

export default CountryBadgesMerged;
